exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-604fe5a0]{width:100%;text-align:center\n}\n.avatars[data-v-604fe5a0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.username[data-v-604fe5a0]{font-size:19px;font-weight:bold;width:35%\n}\n", ""]);

// exports
